import Pong from '../assets/projects/pong.png'
import Path from '../assets/projects/path.png'
import chatBridge from '../assets/projects/chatBridge.png'
import svm from '../assets/projects/svm.png'
import FST from '../assets/projects/fst.png'
import podSnap from '../assets/projects/podSnap.png'
import youtube from '../assets/projects/youtube.png'

export const data=[
    {
        id:1,
        name:"FST App",
        image:FST,
        github:"https://github.com/AnmolGulati6/FST-App",
        live:"",
    },
    {
        id:2,
        name:"AI Pong Game",
        image:Pong,
        github:"https://github.com/AnmolGulati6/Autonomous-Pong-Game",
        live:"",
    },
    {
        id:3,
        name:"PodSnap: Podcast Summarizer",
        image:podSnap,   
        github:"https://github.com/AnmolGulati6/Podcast-Summarizer",
        live:"",
    },
    {
        id:4,
        name:"Youtube Sentiment Analysis",
        image:youtube,
        github:"https://github.com/AnmolGulati6/YouTube-Sentiment-Analyzer",
        live:"",
    },
    {
        id:5,
        name:"Diabetes Prediction: SVMs",
        image:svm,
        github:"https://github.com/AnmolGulati6/Diabetes-Prediction-using-Support-Vector-Machines",
        live:"",
    },
    {

        id:6,
        name:"A* Path Visualizer",
        image:Path,
        github:"https://github.com/AnmolGulati6/A-star-Pathfinder",
        live:"",
    },
    


]